import { render, staticRenderFns } from "./FamilyTypes.vue?vue&type=template&id=766c31d6&"
import script from "./FamilyTypes.vue?vue&type=script&lang=js&"
export * from "./FamilyTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports